import React from "react";
import {Col, Label, Row} from "reactstrap";
import FormInput from "../../../components/common/form/FormInput";
import FormReactSelect from "../../../components/common/form/FormReactSelect";

class SummaryForm extends React.Component {
    showField() {
        return this.props.isEdit === true ? "" : "hidden";
    }

    render() {
        return (
            <>

                <Row>
                    <Col>
                        <FormInput
                            name="text"
                            className="form-control-label"
                            id="text"
                            placeholder="inputPlaceHolder.summary.text"
                            type="editor"
                            onChange={this.props.onEditorChange}
                            label="inputLabel.summary.text"
                            value={this?.props?.valueObj?.text || ""}
                            errorMsg={this?.props?.errorObj?.text || ""}
                            required
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <FormReactSelect
                            selectKey={this.props.attendeesSelectkey}
                            isMulti={true}
                            className="form-control-label"
                            isSearchable={true}
                            isClearable={this.props.isClearable !== undefined ? this.props.isClearable : true}
                            label="Share With Projects"
                            name={"sharedWith"}
                            onChange={this.props.handleAttendeesChange}
                            optionValue={"uniqueId"}
                            defaultValue={this.props.selectedAttendees}
                            optionList={this.props.attendesForSelection}
                            optionLabel={"name"}
                            placeHolder="Select Projects"
                            errorMsg={this.props?.errorObj?.attendees || ""}

                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default SummaryForm;
